// export interface EligbilityForm {
//   student?: OPTION_TYPE;
//   twelfthGradingScheme?: OPTION_TYPE;
//   twelfthGrade?: string | number;
//   ugGradingScheme?: OPTION_TYPE;
//   ugGrade?: string | number;
//   ugBacklogs?: number;
//   pgGradingScheme?: OPTION_TYPE;
//   pgGrade?: string | number;
//   // pgbacklogs?: number;
//   // additionalExam?: OPTION_TYPE;
//   // greExamScore?: number;
//   // gmatExamScore?: number;
//   englishExamType?: OPTION_TYPE;
//   englishTotalScore?: number;
//   listening?: number;
//   reading?: number;
//   writing?: number;
//   speaking?: number;
//   literacy?: number;
//   conversation?: number;
//   comprehension?: number;
//   production?: number;
// }
export var Inputype;
(function (Inputype) {
    Inputype["ASYNC_DROPDOWN"] = "async-dropdown";
    Inputype["DROPDOWN"] = "dropdown";
    Inputype["RAW_INPUT"] = "raw-input";
})(Inputype || (Inputype = {}));
export var EnglishExamTestTypes;
(function (EnglishExamTestTypes) {
    EnglishExamTestTypes["TOEFL"] = "TOEFL";
    EnglishExamTestTypes["IELTS"] = "IELTS";
    EnglishExamTestTypes["PTE"] = "PTE";
    EnglishExamTestTypes["DUOLINGO"] = "DUOLINGO";
})(EnglishExamTestTypes || (EnglishExamTestTypes = {}));
//# sourceMappingURL=types.js.map